<template>
    <div class="bg-white fixed transform transition duration-700 z-50 w-full h-full flex flex-col justify-between top-0 left-0 pb-12 overflow-scroll" :class="navState ? '' : '-translate-x-full' ">
        <div>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="absolute top-10 mt-2 left-8 cursor-pointer" @click="navStateFalse"><path d="M0.410151 12.2938C0.243173 12.4667 0.150778 12.6982 0.152867 12.9386C0.154955 13.1789 0.25136 13.4088 0.421318 13.5788C0.591275 13.7487 0.821186 13.8451 1.06153 13.8472C1.30188 13.8493 1.53343 13.7569 1.70632 13.5899L7.00007 8.29618L12.2938 13.5908C12.3784 13.6784 12.4795 13.7482 12.5914 13.7963C12.7032 13.8443 12.8235 13.8696 12.9452 13.8707C13.0669 13.8717 13.1876 13.8485 13.3003 13.8024C13.4129 13.7563 13.5153 13.6883 13.6013 13.6022C13.6874 13.5161 13.7555 13.4138 13.8016 13.3011C13.8477 13.1885 13.8709 13.0678 13.8698 12.9461C13.8687 12.8244 13.8435 12.7041 13.7954 12.5922C13.7474 12.4804 13.6775 12.3792 13.59 12.2947L8.29623 7.00002L13.59 1.70627C13.757 1.53338 13.8494 1.30183 13.8473 1.06148C13.8452 0.821134 13.7488 0.591222 13.5788 0.421265C13.4089 0.251308 13.1789 0.154904 12.9386 0.152815C12.6983 0.150727 12.4667 0.243122 12.2938 0.410099L7.00007 5.70385L1.70632 0.4101C1.53343 0.243122 1.30188 0.150727 1.06153 0.152816C0.821186 0.154904 0.591275 0.251308 0.421317 0.421266C0.25136 0.591223 0.154955 0.821135 0.152866 1.06148C0.150778 1.30183 0.243172 1.53338 0.410151 1.70627L5.7039 7.00002L0.409234 12.2938L0.410151 12.2938Z" fill="#223672"/></svg>
          <default-header 
              type="dark"
              seperatorClasses="bg-primary"
              :masked="false"
          />
          <!-- <div class="px-6 pb-6 -mt-4">
              <ul class="text-lg pb-6 space-y-8 border-b border-primary border-opacity-20">
                  <li class="flex items-center justify-between" @click="$router.push({ name: 'SOS' }), this.$store.dispatch('setSidebarStatus', false), this.$store.dispatch('setSearchStatus', false)">
                    <a href="" class="transition duration-500 text-primary hover:underline font-sans-secondary">{{ $t('howtousethesos') }}</a>
                    <div>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 12H20M13 5L20 12L13 19" stroke="#223672" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </div>
                  </li>
                  <li class="flex items-center justify-between" @click="$router.push({ name: 'PairLifePass' }), this.$store.dispatch('setSidebarStatus', false), this.$store.dispatch('setSearchStatus', false)">
                    <a href="" class="transition duration-500 text-primary hover:underline font-sans-secondary">{{ $t('howtopairlifepass') }}</a>
                    <div>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 12H20M13 5L20 12L13 19" stroke="#223672" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </div>
                  </li>
                  <li class="flex items-center justify-between" @click="$router.push({ name: 'LightsMeaning' }), this.$store.dispatch('setSidebarStatus', false), this.$store.dispatch('setSearchStatus', false)">
                    <a href="" class="transition duration-500 text-primary hover:underline font-sans-secondary ">{{ $t('indicatorlightsmeaning') }}</a>
                    <div>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 12H20M13 5L20 12L13 19" stroke="#223672" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </div>
                  </li>
                  <li class="flex items-center justify-between" @click="$router.push({ name: 'FAQ' }), this.$store.dispatch('setSidebarStatus', false), this.$store.dispatch('setSearchStatus', false)">
                    <a href="" class="transition duration-500 text-primary hover:underline font-sans-secondary ">{{ $t('needhelpwithyourlifepass') }}</a>
                    <div>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 12H20M13 5L20 12L13 19" stroke="#223672" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </div>
                  </li>
              </ul>
          </div> -->
          <div class="px-6 pb-6 text-primary space-y-6">
              <span class="block text-lg font-sans-secondary">{{ $t('accountinformation') }}</span>
              <div class="grid grid-cols-1 xs:grid-cols-2 gap-x-5 gap-y-6">
                  <div class="flex flex-col">
                      <span class="block text-xs">{{ $t('name') }}</span>
                      <div class="flex items-center space-x-2.5">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_115_956)"><path d="M16 7.992C16 3.58 12.416 0 8 0C3.584 0 0 3.58 0 7.992C0 10.422 1.104 12.612 2.832 14.082C2.848 14.098 2.864 14.098 2.864 14.114C3.008 14.226 3.152 14.338 3.312 14.45C3.392 14.498 3.456 14.561 3.536 14.625C4.85807 15.5214 6.41871 16.0004 8.016 16C9.61329 16.0004 11.1739 15.5214 12.496 14.625C12.576 14.577 12.64 14.514 12.72 14.465C12.864 14.354 13.024 14.242 13.168 14.13C13.184 14.114 13.2 14.114 13.2 14.098C14.896 12.611 16 10.422 16 7.992ZM8 14.993C6.496 14.993 5.12 14.513 3.984 13.714C4 13.586 4.032 13.459 4.064 13.331C4.15934 12.9841 4.29917 12.651 4.48 12.34C4.656 12.036 4.864 11.764 5.12 11.524C5.36 11.284 5.648 11.061 5.936 10.885C6.24 10.709 6.56 10.581 6.912 10.485C7.26674 10.3894 7.6326 10.3413 8 10.342C9.09065 10.3343 10.1412 10.7526 10.928 11.508C11.296 11.876 11.584 12.308 11.792 12.803C11.904 13.091 11.984 13.395 12.032 13.714C10.8512 14.5442 9.44343 14.9907 8 14.993ZM5.552 7.593C5.41102 7.27022 5.34013 6.9212 5.344 6.569C5.344 6.218 5.408 5.866 5.552 5.546C5.696 5.226 5.888 4.939 6.128 4.699C6.368 4.459 6.656 4.268 6.976 4.124C7.296 3.98 7.648 3.916 8 3.916C8.368 3.916 8.704 3.98 9.024 4.124C9.344 4.268 9.632 4.46 9.872 4.699C10.112 4.939 10.304 5.227 10.448 5.546C10.592 5.866 10.656 6.218 10.656 6.569C10.656 6.937 10.592 7.273 10.448 7.592C10.309 7.90727 10.1138 8.19461 9.872 8.44C9.62653 8.68149 9.33919 8.87633 9.024 9.015C8.36283 9.28671 7.62117 9.28671 6.96 9.015C6.64481 8.87633 6.35747 8.68149 6.112 8.44C5.86981 8.19819 5.67929 7.90968 5.552 7.592V7.593ZM12.976 12.899C12.976 12.867 12.96 12.851 12.96 12.819C12.8026 12.3184 12.5707 11.8444 12.272 11.413C11.973 10.9784 11.6056 10.5951 11.184 10.278C10.862 10.0358 10.513 9.83175 10.144 9.67C10.3119 9.55925 10.4674 9.43085 10.608 9.287C10.8465 9.0515 11.056 8.7883 11.232 8.503C11.5864 7.92081 11.7694 7.25049 11.76 6.569C11.7649 6.06451 11.667 5.56432 11.472 5.099C11.2795 4.65064 11.0025 4.24356 10.656 3.9C10.31 3.56003 9.90288 3.28859 9.456 3.1C8.98991 2.90539 8.48906 2.80774 7.984 2.813C7.47887 2.80806 6.97802 2.90605 6.512 3.101C6.06125 3.28919 5.65311 3.56638 5.312 3.916C4.97204 4.26159 4.70059 4.66842 4.512 5.115C4.31705 5.58032 4.21905 6.08051 4.224 6.585C4.224 6.937 4.272 7.273 4.368 7.592C4.464 7.928 4.592 8.232 4.768 8.519C4.928 8.807 5.152 9.063 5.392 9.303C5.536 9.447 5.696 9.574 5.872 9.686C5.50184 9.85206 5.15272 10.0615 4.832 10.31C4.416 10.63 4.048 11.013 3.744 11.429C3.44226 11.8586 3.21008 12.3331 3.056 12.835C3.04 12.867 3.04 12.899 3.04 12.915C1.776 11.636 0.992 9.91 0.992 7.992C0.992 4.14 4.144 0.991 8 0.991C11.856 0.991 15.008 4.14 15.008 7.992C15.0059 9.83196 14.2753 11.5962 12.976 12.899Z" fill="#223672"/></g><defs><clipPath id="clip0_115_956"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>
                          <span class="block text-sm font-sans-secondary">{{ orderInfo ? orderInfo.name : $t('nonamedefault') }}</span>
                      </div>
                  </div>
                  <div class="flex flex-col">
                      <span class="block text-xs">{{ $t('totallifepass') }}</span>
                      <span class="block text-sm font-sans-secondary">{{ orderInfo ? orderInfo.issued : $t('nonamedefault') }}</span>
                  </div>
                  <div class="flex flex-col">
                      <span class="block text-xs">{{ $t('phonenumber') }}</span>
                      <span class="block text-sm font-sans-secondary">{{ orderInfo ? orderInfo.phone : $t('nonamedefault') }}</span>
                  </div>
                  <div class="flex flex-col">
                      <span class="block text-xs">{{ $t('ordernumber') }}</span>
                      <span class="block text-sm font-sans-secondary">{{ orderInfo ? orderInfo.orderId : $t('nonamedefault') }}</span>
                  </div>
              </div>
              <socials-links />
          </div>
        </div>
        <!-- <img src="@/assets/images/logos/fatmapPowered.png" alt="fatmap powered logo." class="w-28 mx-auto"> -->
    </div>
</template>

<script>
import DefaultHeader from "@/components/Header.vue";
import SocialsLinks from "@/components/Socials.vue";

export default {
  name: "Navigation",
  components: {
    DefaultHeader,
    SocialsLinks
  },
  props: [
    'navState'
  ],
  data() {
    return {
      orderInfo: null
    };
  },
  mounted() {
    if(this.$route.query.ac) {
      window.localStorage.setItem('auth', this.$route.query.ac);
      window.localStorage.setItem('oid', this.$route.query.oid);
    }

    this.getorderInformation();
  },
  watch: {
  },
  methods: {
    getorderInformation() {      
      if(window.localStorage.getItem('oid') != null) {

        this.axios
          .get(`${process.env.VUE_APP_API_BASE_URL}/api/app/booking?ac=${window.localStorage.getItem('auth')}&oid=${window.localStorage.getItem('oid')}`)
          .then((res) => {
            this.orderInfo = res;

            if(res.phone !== null){
              if(res.phone.charAt(0) !== '+')
              res.phone = `+${res.phone}`;
            }
            else{
              res.phone = "";
            }

            window.localStorage.setItem('usersMobile', res.phone);
            window.localStorage.setItem('usersName', res.name);
            window.localStorage.setItem('registeredToApp', res.registeredToApp);
            window.localStorage.setItem('passesReturned', res.passesReturned);

            const lanuageManuallyChanged = window.localStorage.getItem('lanuageManuallyChanged');
            
            if(res.language && !lanuageManuallyChanged) { // check if there are any devices returned
              window.localStorage.setItem('selectedLangShort', res.language);
              
              let requiresReload = false;
              if(!window.localStorage.getItem('selectedLanuage'))
                requiresReload = true;

              if(res.language == 'it')
                window.localStorage.setItem('selectedLanuage', 'Italian');
              else if(res.language == 'de')
                window.localStorage.setItem('selectedLanuage', 'German');
              else if(res.language == 'fr')
                window.localStorage.setItem('selectedLanuage', 'French');
              else
                window.localStorage.setItem('selectedLanuage', 'English');

              if(requiresReload){
                this.$router.go(this.$router.currentRoute);
              }

            }
          }).catch(() => {
            localStorage.removeItem('oid');
          }).finally(() => {
            this.loading = false;
          });
      }
    },
    navStateFalse() {
      this.$store.dispatch('setSidebarStatus', false);
    }
  }
};
</script>

<style lang="scss" scoped>
  a {

  }
</style>